import React from 'react';
import chat_details from '../../../../assets/Main/chat_details.svg';
import detail from '../../../../assets/Main/tab_detail.svg';
import profile from '../../../../assets/Main/tab_profile.svg';
import pin from '../../../../assets/Main/chat_pin.svg';
import attencion from '../../../../assets/Main/chat_attencion.svg';
import closed from '../../../../assets/Main/chat_closed.svg';
import support_chat from '../../../../assets/Main/tab_chat.svg';
import icon_checkmark from '../../../../assets/Main/icon_checkmark2.svg';
import back from '../../../../assets/Main/arrow_left_bold.svg';
import icon_user from '../../../../assets/Main/icon_user.svg';
import { getDisplayName, getOrderTitle, getExecutorIdFromChat } from './chatHelpers';


const ChatHeader = ({
  isMobile,
  isExecutor,
  userRole,
  selectedChat,
  goBackToChatList,
  showHeaderMenu,
  setShowHeaderMenu,
  userInfoRef,
  showOptionsMenu,
  setShowOptionsMenu,
  optionsButtonRef,
  headerMenuRef,
  optionsMenuRef,
  navigate,
  propOrderId,
  getOrderIdFromChat,
  goToExecutorProfile,
  currentInvitation,
  showActionButtons,
  declinedInvitations,
  setSelectedExecutorForAction,
  setShowShareContactsModal,
  setShowDeclineConfirmModal,
  shouldShowCustomerHeaderActions,
  collaborationLoading,
  handleCustomerAcceptClick,
  handleCustomerDeclineClick,
  onSelectSupportChat,
  onPinChat, 
  setShowComplaintModal,
  onArchiveChat,
  collaborationState,
  showExecutorContacts,
  onCompleteOrder,
  onShareContacts, // Добавляем пропс для исполнителя
}) => {
  const isSupportChat = selectedChat?.type === 'SUPPORT';

  const headerAvatarSrc = isSupportChat
    ? (selectedChat?.avatarUrl || icon_user)
    : userRole === 'EXECUTOR'
      ? (selectedChat?.customer?.avatarUrl || icon_user)
      : (selectedChat?.selectedExecutorAvatarUrl || selectedChat?.executorAvatarUrl || icon_user);

  const headerTitle = isSupportChat
    ? 'Чат поддержки'
    : getDisplayName(selectedChat, userRole);

  const headerSubtitle = isSupportChat
    ? (selectedChat?.orderTitle ||
       selectedChat?.relatedOrderTitle ||
       selectedChat?.categoryTitle ||
       'Служба поддержки')
    : getOrderTitle(selectedChat);

  const handleUserInfoClick = () => {
    if (isSupportChat) return;
    setShowHeaderMenu(!showHeaderMenu);
  };

  const handleOptionsClick = () => {
    if (isSupportChat) return;
    setShowOptionsMenu(!showOptionsMenu);
  };

  const handlePinChat = () => {
    if (isSupportChat) {
      alert('Чат поддержки всегда закреплен');
      return;
    }
    onPinChat(selectedChat);
    setShowOptionsMenu(false);
  };

  // Проверяем, можно ли показывать кнопку "Завершить заказ"
  const showCompleteOrderButton =
    userRole === 'CUSTOMER' &&
    !isSupportChat &&
    !!collaborationState?.selectedExecutorId &&
    !selectedChat?.closed;

  // Проверяем, нужно ли показывать кнопку "Поделиться контактами" для исполнителя
  const showShareContactsButton = 
    isExecutor && 
    !isSupportChat && 
    collaborationState?.customerPhoneShared && 
    !collaborationState?.executorSocialsShared;

  return (
    <div className="chat-header" style={(isMobile && userRole==='CUSTOMER')?{marginTop:'-123px'}:{marginTop:userRole==='EXECUTOR'&&isMobile?'-45px':''}}>
      <div className="chat-header-left">
        {isMobile && (
          <button className="mobile-back-button" onClick={goBackToChatList} type="button">
            <img src={back} alt="Назад" />
          </button>
        )}

        <div
          className="user-info"
          onClick={handleUserInfoClick}
          ref={userInfoRef}
          style={isSupportChat ? { cursor: 'default' } : { cursor: 'pointer' }}
        >
          <div className="avatar chat-header-avatar">
            <img
              src={headerAvatarSrc}
              alt=""
              style={{
                width: '100%',
                height: '100%',
                borderRadius: '7px',
                objectFit: 'cover',
              }}
            />
          </div>

          <div className="chat-header-user-text">
            <div className="user-name">
              {headerTitle}
              {!isExecutor && !isSupportChat && (
                <img
                  src={icon_checkmark}
                  alt=""
                  style={{
                    marginLeft: '10px',
                    verticalAlign: 'middle',
                    width: isMobile ? '17px' : '',
                    marginTop: isMobile ? '-5px' : '',
                  }}
                />
              )}
            </div>
            <div className="user-last-online">{headerSubtitle}</div>
          </div>
        </div>
      </div>

      {!isSupportChat && isExecutor && !isMobile && currentInvitation && showActionButtons && (
        <div className="desktop-header-actions">
          {declinedInvitations.has(selectedChat?.invitationId) ? (
            <span style={{ color: '#dc3545', fontWeight: 600 }}>ОТКЛОНЕНО</span>
          ) : (
            <>
              <button
                onClick={() => {
                  setSelectedExecutorForAction(currentInvitation);
                  setShowShareContactsModal(true);
                }}
                className="header-action-accept"
              >
                Принять
              </button>

              <button
                onClick={() => {
                  setSelectedExecutorForAction(currentInvitation);
                  setShowDeclineConfirmModal(true);
                }}
                className="header-action-decline"
              >
                Отклонить
              </button>
            </>
          )}
        </div>
      )}

      {/* Кнопка для исполнителя "Поделиться контактами" */}
      {showShareContactsButton && (
        <button
          onClick={onShareContacts}
          className="header-action-accept"
          style={{
            marginRight: '10px',
            padding: '8px 16px',
            background: '#DE5A2B',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontWeight: 500
          }}
        >
          Поделиться контактами
        </button>
      )}

      {/* Кнопка для заказчика "Завершить заказ" */}
      {showCompleteOrderButton && (
        <button
          onClick={onCompleteOrder}
          className="header-action-complete"
          style={{
            marginRight: '10px',
            padding: '8px 16px',
            background: '#DE5A2B',
            color: 'white',
            border: 'none',
            borderRadius: '7px',
            cursor: 'pointer',
            fontWeight: 500
          }}
        >
          Завершить заказ
        </button>
      )}

      {!isSupportChat && shouldShowCustomerHeaderActions && !isMobile && (
        <div className="desktop-header-actions">
          <button
            onClick={handleCustomerDeclineClick}
            className="header-action-decline"
            disabled={collaborationLoading}
          >
            {collaborationLoading ? '...' : 'Отклонить'}
          </button>

          <button
            onClick={handleCustomerAcceptClick}
            className="header-action-accept"
            disabled={collaborationLoading}
          >
            {collaborationLoading ? '...' : 'Принять отклик'}
          </button>
        </div>
      )}

      <div
        className={`options ${isSupportChat ? 'support-options' : ''}`}
        onClick={handleOptionsClick}
        ref={optionsButtonRef}
        role="button"
        aria-label="Меню чата"
      >
        <img src={chat_details} alt="Детали" />
      </div>

      {!isSupportChat && showHeaderMenu && (
        <div className="header-menu" ref={headerMenuRef}>
          <div
            className="menu-item big"
            onClick={() => navigate(`/order/${propOrderId || getOrderIdFromChat()}`)}
          >
            <img src={detail} alt="" style={{ marginRight: '7px' }} />
            Посмотреть детали заказа
          </div>

          <div
            className="menu-item big"
            onClick={() => goToExecutorProfile(getExecutorIdFromChat(selectedChat))}
            style={{ cursor: 'pointer' }}
          >
            <img src={profile} alt="" style={{ marginRight: '7px' }} />
            Посмотреть профиль исполнителя
          </div>
        </div>
      )}

      {!isSupportChat && showOptionsMenu && (
        <div className="options-menu" ref={optionsMenuRef}>
          <div className="menu-item" onClick={handlePinChat}>
            <img src={pin} alt="" style={{ marginRight: '7px' }} />
            {selectedChat?.isPinned ? 'Открепить чат' : 'Закрепить чат'}
          </div>
          <div
            className="menu-item"
            onClick={() => {
              setShowComplaintModal(true);
              setShowOptionsMenu(false);
            }}
          >
            <img src={attencion} alt="" style={{ marginRight: '7px' }} />
            Пожаловаться
          </div>
          <div 
            className="menu-item" 
            onClick={() => {
              if (onArchiveChat) {
                onArchiveChat(selectedChat);
                setShowOptionsMenu(false);
              }
            }}
          >
            <img src={closed} alt="" style={{ marginRight: '7px' }} />
            Скрыть чат
          </div>
          <div
            className="menu-item"
            onClick={() => {
              const supportChat = {
                id: 'support-chat-rulla',
                chatId: 'support-chat-rulla',
                type: 'SUPPORT',
                title: 'Чат поддержки',
                avatarUrl: null,
                orderTitle: 'Служба поддержки',
                lastMessageAt: new Date().toISOString(),
                lastMessageText: 'Здравствуйте! Это служба поддержки платформы Rulla.',
                lastMessageRead: true,
                unreadMessagesCount: 0,
                isPinned: true,
              };
              
              onSelectSupportChat(supportChat);
              setShowOptionsMenu(false);
            }}
          >
            <img src={support_chat} alt="" style={{ marginRight: '7px', width: '24px' }} />
            Чат поддержки Rulla
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatHeader;
